import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { format, subDays, subHours } from 'date-fns';
import {Avatar,Box,IconButton,Link,List,ListItem,ListItemAvatar,ListItemText,Popover,Tooltip,Typography } from '@mui/material';
import { ChatAlt as ChatAltIcon } from '../../icons/chat-alt';
import { MailOpen as MailOpenIcon } from '../../icons/mail-open';
import CampaignIcon from '@mui/icons-material/Campaign';
import { X as XIcon } from '../../icons/x';
import { UserCircle as UserCircleIcon } from '../../icons/user-circle';
import { Scrollbar } from '../scrollbar';
import { db } from '../../lib/firebase';
import { getDocs,query,onSnapshot,collection,addDoc,Timestamp,where,getDoc,doc,orderBy,limit } from 'firebase/firestore';
import { useAuth } from '../../hooks/use-auth';
import toast from 'react-hot-toast';
import { tr } from 'date-fns/locale';

const now = new Date();

const data = [
  {
    id: '5e8883f1b51cc1956a5a1ec0',
    author: 'Gerardo Hernandez',
    avatar: '/static/mock-images/avatars/avatar-ghg.jpeg',
    createdAt: subHours(now, 2).getTime(),
    job: 'Importación camiones',
    read: true,
    type: 'job_add',
  },
  {
    id: '5e8883f1b51cc1956a5a1ec1',
    createdAt: subHours(now, 2).getTime(),
    text: 'Recuerda llamar al cliente Juan Perez',
    link: '/dashboard/1',
    linkText: 'Ver cliente',
    read: false,
    type: 'reminder'
  },
  {
    id: '5e8883f1b51cc1956a5a1ec1',
    createdAt: subHours(now, 2).getTime(),
    text: 'Se actualizo tu oportunidad a: ',
    link: '/dashboard/oportunidades/oportunidadId',
    linkText: 'Ver Oportunidad',
    read: false,
    type: 'statusOportunity'
  }
];


const getNotificationContent = (notification) => {
  switch (notification.type) {
    case 'reminder':
      return (
        <>
          <ListItemAvatar sx={{ mt: 0.5 }}>
            <Avatar>
              <CampaignIcon fontSize="small" />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={(
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexWrap: 'wrap'
                }}
              >
                <Typography
                  sx={{ mr: 0.5 }}
                  variant="subtitle2"
                >
                  Recordatorio
                </Typography>
                <Typography
                  sx={{ mr: 0.5 }}
                  variant="body2"
                >
                  {notification.text}
                </Typography>
                <Link
                  href={notification.link}
                  underline="always"
                  variant="body2"
                >
                  {notification.linkText}
                </Link>
              </Box>
            )}
            secondary={(
              <Typography
                color="textSecondary"
                variant="caption"
              >
                {format(notification.createdAt, 'MMM dd, h:mm a')}
              </Typography>
            )}
            sx={{ my: 0 }}
          />
        </>
      );
    case 'statusOportunity':
      return (
        <>
          <ListItemAvatar sx={{ mt: 0.5 }}>
            <Avatar>
              <CampaignIcon fontSize="small" />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={(
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexWrap: 'wrap'
                }}
              >
                <Typography
                  sx={{ mr: 0.5 }}
                  variant="subtitle2"
                >
                  Estatus de la oportunidad actualizado
                </Typography>
                <Typography
                  sx={{ mr: 0.5 }}
                  variant="body2"
                >
                  {notification.text}
                </Typography>
                <Link
                  href={notification.link}
                  underline="always"
                  variant="body2"
                >
                  {notification.linkText}
                </Link>
              </Box>
            )}
            secondary={(
              <Typography
                color="textSecondary"
                variant="caption"
              >
                {
                  //Comvertir timestamp a fecha con formato 'MMM dd, h:mm a'
                  format(new Date(notification.createdAt.seconds * 1000), 'MMM dd, h:mm a')
                }
              </Typography>
            )}
            sx={{ my: 0 }}
          />
        </>
      );
    case 'job_add':
      return (
        <>
          <ListItemAvatar sx={{ mt: 0.5 }}>
            <Avatar src={notification.avatar}>
              <UserCircleIcon fontSize="small" />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={(
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexWrap: 'wrap'
                }}
              >
                <Typography
                  sx={{ mr: 0.5 }}
                  variant="subtitle2"
                >
                  {notification.author}
                </Typography>
                <Typography
                  sx={{ mr: 0.5 }}
                  variant="body2"
                >
                  añadió una nueva tarea
                </Typography>
                <Link
                  href="/dashboard/jobs"
                  underline="always"
                  variant="body2"
                >
                  {notification.job}
                </Link>
              </Box>
            )}
            secondary={(
              <Typography
                color="textSecondary"
                variant="caption"
              >
                {format(notification.createdAt, 'MMM dd, h:mm a')}
              </Typography>
            )}
            sx={{ my: 0 }}
          />
        </>
      );
    case 'new_feature':
      return (
        <>
          <ListItemAvatar sx={{ mt: 0.5 }}>
            <Avatar>
              <ChatAltIcon fontSize="small" />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={(
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexWrap: 'wrap'
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ mr: 0.5 }}
                >
                  New feature!
                </Typography>
                <Typography variant="body2">
                  {notification.description}
                </Typography>
              </Box>
            )}
            secondary={(
              <Typography
                color="textSecondary"
                variant="caption"
              >
                {format(notification.createdAt, 'MMM dd, h:mm a')}
              </Typography>
            )}
            sx={{ my: 0 }}
          />
        </>
      );
    case 'company_created':
      return (
        <>
          <ListItemAvatar sx={{ mt: 0.5 }}>
            <Avatar src={notification.avatar}>
              <UserCircleIcon fontSize="small" />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={(
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexWrap: 'wrap',
                  m: 0
                }}
              >
                <Typography
                  sx={{ mr: 0.5 }}
                  variant="subtitle2"
                >
                  {notification.author}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ mr: 0.5 }}
                >
                  created
                </Typography>
                <Link
                  href="/dashboard/jobs"
                  underline="always"
                  variant="body2"
                >
                  {notification.company}
                </Link>
              </Box>
            )}
            secondary={(
              <Typography
                color="textSecondary"
                variant="caption"
              >
                {format(notification.createdAt, 'MMM dd, h:mm a')}
              </Typography>
            )}
            sx={{ my: 0 }}
          />
        </>
      );
    default:
      return null;
  }
};

export const NotificationsPopover = (props) => {
  const { anchorEl, onClose, onUpdateUnread, open, ...other } = props;
  const [notifications, setNotifications] = useState([]);
  const unread = useMemo(() => notifications.reduce((acc, notification) => acc + (notification.read
    ? 0
    : 1), 0), [notifications]);

  useEffect(() => {
    onUpdateUnread?.(unread);
  }, [onUpdateUnread, unread]);


  const { user } = useAuth();

  const MarcarTodasComoLeidas = async () => {
    try {
      // Perform the API call to update the user name
      const response = await fetch('/api/v1/notifications/statusOportunity', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user: user?.id }),
      });
      const data = await response.json();
      if (data.ok) {
        toast.success('Notificaciones marcadas como leídas');
      } else {
        toast.error('Error al marcar como leidas las notificaciones');
      }
    }catch (error) {
      toast.error('Error al marcar como leidas las notificaciones');
    }
  }

  const MarcarComoLeida = async (id) => {
    //Mandar peticion a la API para marcar como leida la notificacion
    try {
      // Perform the API call to update the user name
      const response = await fetch('/api/v1/notifications/statusOportunity', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),
      });
      const data = await response.json();
      if (data.ok) {
        toast.success('Notificación marcada como leída');
      } else {
        toast.error('Error al marcar como leída la notificación');
      }
    } catch (error) {
      toast.error('Error al marcar como leída la notificación');
    }

  };

  const EliminarNotificacion = async (id) => {
    //Mandar peticion a la API para eliminar la notificacion
    try {
      // Perform the API call to update the user name
      const response = await fetch('/api/v1/notifications/statusOportunity', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),
      });
      const data = await response.json();
      if (data.ok) {
        toast.success('Notificación eliminada');
      } else {
        toast.error('Error al eliminar la notificación');
      }
    } catch (error) {
      toast.error('Error al eliminar la notificación');
    }
  };

  //Traer las notificaciones 
  useEffect(() => {
    const traerNotificaciones = async () => {
      if (!user) return;

      try {
        const q = query(collection(db, "notificaciones"), where("userId", "==", user?.id), where("read", "==", false),  limit(5));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const notificaciones = [];
          querySnapshot.forEach((doc) => {
            notificaciones.push({ ...doc.data(), id: doc.id });
          });
          setNotifications(notificaciones);
        });
        return unsubscribe;
      }catch (error) {
        toast.error('Error al traer las notificaciones.');
      }
    }
    
    traerNotificaciones();
  }, [user?.id]);

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom'
      }}
      onClose={onClose}
      open={!!open}
      PaperProps={{ sx: { width: 380 } }}
      transitionDuration={0}
      {...other}>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
          display: 'flex',
          justifyContent: 'space-between',
          px: 3,
          py: 2
        }}
      >
        <Typography
          color="inherit"
          variant="h6"
        >
          Notificaciones
        </Typography>
        <Tooltip title="Marcar todas como leídas">
          <IconButton
            onClick={MarcarTodasComoLeidas}
            disabled={notifications.length === 0}
            size="small"
            sx={{ color: 'inherit' }}
          >
            <MailOpenIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      {notifications.length === 0
        ? (
          <Box sx={{ p: 2 }}>
            <Typography variant="subtitle2">
              No tienes notificaciones
            </Typography>
          </Box>
        )
        : (
          <Scrollbar sx={{ maxHeight: 400 }}>
            <List disablePadding>
              {notifications.map((notification) => (
                <ListItem
                  divider
                  key={notification.id}
                  sx={{
                    alignItems: 'flex-start',
                    '&:hover': {
                      backgroundColor: 'action.hover'
                    },
                    '& .MuiListItemSecondaryAction-root': {
                      top: '24%'
                    }
                  }}
                  secondaryAction={(
                    <Tooltip title="Eliminar">
                      <IconButton
                        edge="end"
                        onClick={() => EliminarNotificacion(notification.id)}
                        size="small"
                      >
                        <XIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                >
                  {getNotificationContent(notification)}
                </ListItem>
              ))}
            </List>
          </Scrollbar>
        )}
    </Popover>
  );
};

NotificationsPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  onUpdateUnread: PropTypes.func,
  open: PropTypes.bool
};
